import { defaults as baseDefaults } from "tsi-common-react/src/apps/retail/defaults";
import { ILocationLatLon } from "tsi-common-react/src/models/location";
import {
    isoLatitude,
    isoLongitude,
    isoMiles,
} from "tsi-common-react/src/models/nominals";
import { milesToMeters } from "tsi-common-react/src/utils/maps";

import { RetailState } from "./models";

export const defaults: Readonly<RetailState> = {
    ...baseDefaults,
    productAvailability: {},
    selectedProduct: null,
    flagshipStorePages: {},
    storeFilters: {
        limit: 5,
        // Default distance: 20 miles (converted to meters for internal representation)
        distance: milesToMeters(isoMiles.wrap(20)),
        category: null,
        retailerName: [],
    },
};

export const defaultLocation: ILocationLatLon = {
    formatted_address: "Lexington, KY",
    lat: isoLatitude.wrap("38.029722"),
    lng: isoLongitude.wrap("-84.494722"),
};
